module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/pets//add-btn.png?v=2c99ab02";